import Component from '../../shared/component';

// @class FlaggingContainer
// @param {flaggingForm} opts.flaggingForm Initialized FlaggingForm component
export default class FlaggingContainer extends Component {
  constructor(element, opts) {
    super(...arguments);

    this.$element = $(element);
    this.$flaggingForm = opts.flaggingForm;

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$element.on(
      'click.FlaggingContainer',
      '.flaggableItem',
      this.handleClick
    );
  }

  unbindEvents() {
    this.$element.off(
      'click.FlaggingContainer',
      '.flaggableItem',
      this.handleClick
    );
  }

  handleClick(event) {
    const flaggableItem = $(event.target).closest('.flaggableItem');

    this.$flaggingForm.setFlaggableType(
      flaggableItem.attr('data-flaggable-type')
    );
    this.$flaggingForm.setFlaggableId(flaggableItem.attr('data-flaggable-id'));

    this.$flaggingForm.display();
  }
}
